import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      light: '#FEFBF3',
      main: '#FEFBF3',
      dark: '#002884',
      contrastText: '#fff',
    },
    secondary: {
      light: '#79B4B7',
      main: '#79B4B7',
      dark: '#ba000d',
      contrastText: '#000',
    },
    accent: {
      light: '#9D9D9D',
      main: '#9D9D9D',
      dark: '#ba000d',
      contrastText: '#000',
    },
    light: {
      light: '#F8F0DF',
      main: '#F8F0DF',
      dark: '#ba000d',
      contrastText: '#000',
    },
  },
});

export default theme;